import './Footer.css';

export default function Footer() {
  return (
    <footer id='footer'>
      <div className='footer--container'>
        <p>
          Copryright &copy; 2023 by <span>LocalArt CO</span>
        </p>
      </div>
    </footer>
  );
}
